module.exports = __webpack_public_path__ + "img/2-2.4da55880.jpg";